<template>
  <div>
    <div
      style="font-size: 32px;
    color: #12aba3;
    position: absolute;
    font-weight: 600;
    margin-top: -5px;"
    >
      {{ $t('src/components/training/trainingecg.9764', { '1': this.currentHR }) }}
    </div>
    <div class="d-flex justify-content-end mb-3">
      <div class="dropdown-container">
        <base-dropdown-select
          :options="listScaleX"
          v-model="scaleX"
          class="dropdown-min-select wider index"
        ></base-dropdown-select>

        <base-dropdown-select
          :options="listScaleY"
          v-model="scaleY"
          class="dropdown-min-select index"
        ></base-dropdown-select>
        <base-dropdown-select
          v-if="moduleInstance && isChangeECG"
          :options="listChannel"
          v-model.number="nChannel"
          class="dropdown-min-select bounded wider index"
        ></base-dropdown-select>
      </div>
    </div>
    <div id="canvas-conteiner" class="canvas-conteiner">
      <canvas class="myCanvas" id="myCanvas"></canvas>
      <canvas class="canvas-ruler" id="canvasTime"></canvas>
      <canvas class="canvas-ruler" id="canvasEcg"></canvas>
    </div>
  </div>
</template>

<script>
import('@/styles/components/chart.less')
import { subscribeMobileECG } from '@/mixins/subscribe-mobile-ecg.js'
import { wasmFilter } from '@/mixins/wasm-filter.js'
import dotnet from '@/assets/dotnet/dotnet.js'
import { useEcgCanvas } from '@/mixins/ecg-canvas.js'
import { useEcgOnlineCanvas } from '@/mixins/ecg-online-canvas.js'

export default {
  name: 'TrainingEcgRealTime',
  components: {
    BaseDropdownSelect: () => import('@/base/BaseDropdownSelect.vue')
  },
  mixins: [subscribeMobileECG, wasmFilter, useEcgCanvas, useEcgOnlineCanvas],
  props: {
    currentHR: {
      type: Number,
      required: false
    }
  },
  data: function() {
    return {
      time: 0,
      maxY: [],
      minY: [],
      storageMaxY: [],
      storageMinY: [],
      lastData: [],
      listScaleX: {
        25: `25 ${this.$t('unit.mm/s')}`,
        50: `50 ${this.$t('unit.mm/s')}`,
        75: `75 ${this.$t('unit.mm/s')}`,
        100: `100 ${this.$t('unit.mm/s')}`
      },
      scaleX: '25',
      listScaleY: {
        10: `10 ${this.$t('unit.mm/mv')}`,
        20: `20 ${this.$t('unit.mm/mv')}`,
        40: `40 ${this.$t('unit.mm/mv')}`,
        80: `80 ${this.$t('unit.mm/mv')}`
      },
      scaleY: '10',
      localBuffer: [],
      localBufferNotFilter: [],
      moduleInstance: null,
      source: null,
      dest: null,
      pointOfTime: [],
      mappedId: null,
      leadscount: null,
      nChannel: 1,
      generalLeads: null,
      titleSignals: ['I', 'II', 'III', 'aVR', 'aVL', 'aVF', 'V1', 'V2', 'V3', 'V4', 'V5', 'V6'],
      coordinateGraph: [],
      countPoint: 0,
      animationId: null,
      dotnet: null,
      initFilters: null,
      doFilter: null,
      coefX: 2,
      nbOfSamples: null,
      loaded: true,
      drawLoading: false,
      indexFilter: null,
      visibilityHandler: null,
      forceRender: false,
      needsResize: false
    }
  },
  watch: {
    scaleX() {
      this.countPoint = 0
      this.time = 0
      this.createCanvas()
    },
    scaleY() {
      this.countPoint = 0
      this.setScaleY()
      this.time = 0
      this.ctxEcg.clearRect(0, 0, this.canvasEcg.width, this.canvasEcg.height)
      this.createCanvas()
    },
    nChannel() {
      this.countPoint = 0
      this.coordinateGraph = []
      this.leadscount = this.nChannel === this.generalLeads + 1 ? this.generalLeads : 1
      if (!this.manageWasmBuffers('init')) return
      this.time = 0
      this.ctxEcg.clearRect(0, 0, this.canvasEcg.width, this.canvasEcg.height)
      this.localBuffer = []
      this.createCanvas()
    },
    coordinateGraph() {
      for (let i = 0; i < this.coordinateGraph.length; i++) {
        this.ctx.font = '16px Arial'
        this.ctx.fillStyle = 'rgb(28, 179, 170)'
        this.ctx.fillText(`${this.titleSignals[i]}`, 30, this.coordinateGraph[i])
      }
    }
  },
  computed: {
    trainingId() {
      return this.$route.params.id
    },
    listChannel() {
      let opt = {}

      for (let i = 0; i < this.generalLeads; i++) {
        opt[i + 1] = `ECG ${this.titleSignals[i]}`
      }
      if (this.generalLeads > 1) {
        opt[this.generalLeads + 1] = this.$t('role.all')
      }
      return opt
    },
    isChangeECG() {
      return this.generalLeads && this.generalLeads > 2
    }
  },
  mounted() {
    window.onbeforeunload = function() {
      return
    }

    let promiseWasmFilter = new Promise(resolve => {
      this.dotnet = dotnet
      if (this.dotnet.getBootStatus() === 'Standby') {
        this.dotnet.boot()
      }
      resolve(this.dotnet)
    })

    promiseWasmFilter
      .then(dotnet => {
        if (!dotnet || !dotnet.WasmFilter) {
          throw new Error('WASM module initialization failed')
        }
        let globalThis = require('globalthis/polyfill')() // returns native globalThis if compliant
        this.moduleInstance = globalThis.Module
        this.initFilters = dotnet.WasmFilter.initFilters
        this.doFilter = dotnet.WasmFilter.doFilters
      })
      .then(() => {
        this.loaded = false
      })
      .then(() => {
        this.canSubscribe = true
      })
      .catch(error => {
        console.error('WASM error:', error)
      })

    let self = this
    this.visibilityHandler = () => {
      if (document.visibilityState === 'visible') {
        if (self.localBuffer[0].length >= 7) {
          for (let i = 0; i < self.localBuffer.length; i++) {
            self.localBuffer[i].splice(0, self.localBuffer[i].length - 4)
          }

          self.time = 0
          self.ctxEcg.clearRect(0, 0, self.canvasEcg.width, self.canvasEcg.height)
        }
      }
    }

    document.addEventListener('visibilitychange', this.visibilityHandler)
  },
  beforeDestroy() {
    try {
      document.removeEventListener('visibilitychange', this.visibilityHandler)
    } catch (e) {
      console.warn('Error removing visibility listener:', e)
    }

    if (this.animationId) {
      cancelAnimationFrame(this.animationId)
      this.animationId = null
    }

    this.manageWasmBuffers('free')
  },
  methods: {
    createCanvas() {
      if (!this.leadscount || this.minY.length < this.leadscount || this.maxY.length < this.leadscount) {
        console.warn('Canvas creation delayed: missing channel data')
        return
      }

      const width = this.$el.clientWidth - 7
      let chartHeight = 0

      for (let leadNumber = 0; leadNumber < this.leadscount; leadNumber++) {
        chartHeight =
          chartHeight +
          (this.maxY[leadNumber] - this.minY[leadNumber]) * 4000 * +this.scaleY +
          this.scaleY * 6
      }

      const height = Math.max(chartHeight + 25, 100)

      const mainCanvas = this.initCanvas('myCanvas', width, height)
      const timeCanvas = this.initCanvas('canvasTime', width, height)
      const ecgCanvas = this.initCanvas('canvasEcg', width, height)

      if (!mainCanvas || !timeCanvas || !ecgCanvas) return

      this.canvas = mainCanvas.canvas
      this.ctx = mainCanvas.ctx
      this.canvasTime = timeCanvas.canvas
      this.ctxTime = timeCanvas.ctx
      this.canvasEcg = ecgCanvas.canvas
      this.ctxEcg = ecgCanvas.ctx

      const container = document.getElementById('canvas-conteiner')
      container.style.height = height <= 500 ? 'auto' : '500px'

      this.drawGrid(this.ctx, width, height, this.scaleX, this.scaleY, this.pointOfTime)

      this.ctxEcg.lineWidth = 1
      this.ctxEcg.strokeStyle = 'rgb(79, 79, 79)'
    },
    changeDataByECG(signal) {
      this.changeData(signal, {
        fixedLeadscount: false,
        fixedArraySize: false,
        logErrors: false
      })
    }
  }
}
</script>
